import { createApp } from 'vue'
import { store } from '@/classes/Store'
import App from './App.vue'
import router from '@/classes/Router'
import CorePlugin from '@/plugins/Core'
import CommonComponents from "@/components/commonComponents";

console.log( '%c * lovepod version ' + process.env.VERSION + '@' + process.env.BRANCH, 'background:#cefece; color:#2c992c;' )

const app = createApp( {
    extends: App,
    mixins:  []
} ).use( router )
   .use( store )
   .use( CorePlugin, store, router )

CommonComponents.forEach( component =>
{
    app.component( component.name, component )
} )

app.config.devtools = false
app.mount( '#app' )